import { Injectable } from '@angular/core';
import {
  BooleanCons,
  ExcludeDescriptionCatalog, NumberCons, StorageConst,
  StringConst
} from '../constants/const';
import { CatalogClassification, CatalogField, ICatalogs } from '../model/http/catalogs';
import {
  AdvisorInfoSAP,
  ClientDoctorModel
} from '../model/http/clientDoctorModel';
import { CreditValidation } from '../model/http/creditResponse.model';
import {
  BackIProductDetailStorage
} from '../model/http/historyOrders.model';
import { OptionsHome } from '../model/http/home.model';
import { MissingProduct } from '../model/http/missingProduct.model';
import { InvoiceTab, ShoppingTab } from '../model/http/myActivity.model';
import { DataDialogPrescriptionNameInfo } from '../model/http/prescriptionName';
import {
  CreatePaymentCard,
  IMyProfile,
  PaymentCard
} from '../model/http/profile.model';
import { PayInvoicesData } from '../model/local/changePayMethod';
import { CustomPaginatorEvent, SearchValue } from '../model/local/customPaginator.model';
import { Pagination, TabsMissingProducts } from '../model/local/general.model';
import { OrdersCounterDetail } from '../model/local/menu-items.model';
import { OpenOrdersReport } from '../model/local/OpenOrdersReport.model';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() { }

  setSavePaymentCard(card: CreatePaymentCard): void {
    localStorage.setItem(StorageConst.card, JSON.stringify(card));
  }

  getSavePaymentCard(): CreatePaymentCard {
    const createPaymentCard: CreatePaymentCard = {
      tokenId: '',
      cardCode: '',
      paymentCard: new PaymentCard(),
      doctorName: '',
      email: '',
      isSelected: 0,
    };
    const cardStr =
      localStorage.getItem(StorageConst.card) ??
      JSON.stringify(createPaymentCard);
    const card = JSON.parse(cardStr) as CreatePaymentCard;
    return card;
  }

  removePaymentCard(): void {
    localStorage.removeItem(StorageConst.card);
  }

  getHeaderInfo(): IMyProfile {
    let profileObject = new IMyProfile();
    const infoStr =
      localStorage.getItem(StorageConst.myProfile) ??
      JSON.stringify(new IMyProfile());
    profileObject = JSON.parse(infoStr) as IMyProfile;
    return profileObject;
  }

  setHeaderInfo(info: IMyProfile): void {
    localStorage.setItem(StorageConst.myProfile, JSON.stringify(info));
  }

  setCardCodeDoctorFromAdvisorRole(cardCode: string): void {
    localStorage.setItem(StorageConst.cardCodeDoctorFromAdvisor, cardCode);
  }

  getCardCodeDoctorFromAdvisorRole(): string {
    return (
      localStorage.getItem(StorageConst.cardCodeDoctorFromAdvisor) ??
      StringConst.empty
    );
  }

  setProfilePhoto(url: string): void {
    localStorage.setItem(StorageConst.profilePhoto, url);
  }

  getProfilePhoto(): string {
    return localStorage.getItem(StorageConst.profilePhoto) ?? StringConst.empty;
  }

  setAdvisorInformationFromSAP(info: AdvisorInfoSAP): void {
    localStorage.setItem(StorageConst.advisorCardCode, JSON.stringify(info));
  }

  getAdvisorInformationFromSAP(): AdvisorInfoSAP {
    let advisorInfo = new AdvisorInfoSAP();
    const infoStr =
      localStorage.getItem(StorageConst.advisorCardCode) ??
      JSON.stringify(new AdvisorInfoSAP());
    advisorInfo = JSON.parse(infoStr) as AdvisorInfoSAP;
    return advisorInfo;
  }

  getToken(): string {
    return localStorage.getItem('token') ?? '';
  }

  setToken(token: string): void {
    localStorage.setItem('token', token);
  }

  setCardCode(cardCode: string): void {
    localStorage.setItem(StorageConst.cardCode, cardCode);
  }

  getCardCode(): string {
    return localStorage.getItem(StorageConst.cardCode) ?? StringConst.empty;
  }

  setPriceList(priceList: string): void {
    localStorage.setItem(StorageConst.priceList, priceList);
  }

  getPriceList(): number {
    const priceListId = localStorage.getItem(StorageConst.priceList) ?? StringConst.empty;
    return Number(priceListId);
  }

  setClientType(clientType: string): void {
    localStorage.setItem(StorageConst.clientType, clientType);
  }

  getClientType(): string {
    return localStorage.getItem(StorageConst.clientType) ?? StringConst.empty;
  }

  setCardCodeGeneral(cardCode: string): void {
    localStorage.setItem(StorageConst.cardCodeGeneral, cardCode);
  }

  getCardCodeGeneral(): string {
    return (
      localStorage.getItem(StorageConst.cardCodeGeneral) ?? StringConst.empty
    );
  }

  setOrdersQuantity(orders: OrdersCounterDetail): void {
    localStorage.setItem(StorageConst.counterOrders, JSON.stringify(orders));
  }

  getOrdersQuantity(): OrdersCounterDetail {
    let ordersQuantity = new OrdersCounterDetail();
    const orderStorage =
      localStorage.getItem(StorageConst.counterOrders) ??
      JSON.stringify(new OrdersCounterDetail());
    ordersQuantity = JSON.parse(orderStorage);
    return ordersQuantity;
  }

  setHomeImages(images: OptionsHome): void {
    localStorage.setItem(StorageConst.homeInfo, JSON.stringify(images));
  }

  getHomeImages(): OptionsHome {
    let homeOptions = new OptionsHome();
    const item =
      localStorage.getItem(StorageConst.homeInfo) ??
      JSON.stringify(new OptionsHome());
    homeOptions = JSON.parse(item) as OptionsHome;
    return homeOptions;
  }

  getUserInRole(): string {
    return localStorage.getItem(StorageConst.userInRole) ?? StringConst.empty;
  }

  setUserInRole(role: string): void {
    localStorage.setItem(StorageConst.userInRole, role);
  }

  setClasificationCatalogOld(clasification: string[]): void {
    localStorage.setItem(
      StorageConst.oldClasificationCatalog,
      JSON.stringify(clasification)
    );
  }
  setClasificationCatalog(clasification: CatalogClassification[]): void {
    localStorage.setItem(
      StorageConst.clasificationCatalog,
      JSON.stringify(clasification)
    );
  }

  getClasificationCatalogOld(): string[] {
    const objectEdit =
      localStorage.getItem(StorageConst.oldClasificationCatalog) ??
      JSON.stringify(new Array());
    return JSON.parse(objectEdit);
  }
  getClasificationCatalog(): CatalogClassification[] {
    const objectEdit =
      localStorage.getItem(StorageConst.clasificationCatalog) ??
      JSON.stringify(new Array());
    return JSON.parse(objectEdit);
  }

  setAdvisorClasificationCatalog(clasification: CatalogClassification[]): void {
    localStorage.setItem(
      StorageConst.advisorClasificationCatalog,
      JSON.stringify(clasification)
    );
  }

  getAdvisorClasificationCatalog(): CatalogClassification[] {
    const objectEdit = localStorage.getItem(StorageConst.advisorClasificationCatalog) ??
      JSON.stringify(new Array());
    return JSON.parse(objectEdit);
  }

  clearSession(): void {
    localStorage.clear();
    sessionStorage.clear();
  }

  setLabelsCatalog(labels: ICatalogs[]): void {
    const labelsSorted = this.orderCatalog(
      labels,
      ExcludeDescriptionCatalog.noApplyLabel
    );
    localStorage.setItem(StorageConst.labels, JSON.stringify(labelsSorted));
  }

  getLabelsCatalog(): ICatalogs[] {
    const labelsStr =
      localStorage.getItem(StorageConst.labels) ?? JSON.stringify(new Array());
    return JSON.parse(labelsStr);
  }

  orderCatalog(catalogs: ICatalogs[], itemToExclude: string): ICatalogs[] {
    const index = catalogs.findIndex(
      (catalog) => catalog.description === itemToExclude
    );
    if (index > 0) {
      const itemDeleted = catalogs.splice(index, 1);
      catalogs.sort((a, b) =>
        a.description > b.description
          ? 1
          : a.description < b.description
            ? -1
            : 0
      );
      catalogs.push(itemDeleted[0]);
    }
    return catalogs;
  }

  getContainersCatalog(): ICatalogs[] {
    let containerCatalogs: ICatalogs[] = [];
    const containersStr =
      localStorage.getItem(StorageConst.constainers) ??
      JSON.stringify(new Array());
    containerCatalogs = JSON.parse(containersStr);
    return containerCatalogs;
  }

  removeToken(): void {
    localStorage.removeItem('token');
  }

  userIsAuthenticated(): boolean {
    return Boolean(localStorage.getItem('token'));
  }

  setDoctorSapInfo(doctorInfo: IMyProfile): void {
    localStorage.setItem(
      StorageConst.doctorSapInfo,
      JSON.stringify(doctorInfo)
    );
  }

  setClientDoctor(info: ClientDoctorModel): void {
    localStorage.setItem(StorageConst.objectClient, JSON.stringify(info));
  }

  getClientDoctor(): ClientDoctorModel {
    let clientObject = new ClientDoctorModel();
    const objectClient =
      localStorage.getItem(StorageConst.objectClient) ??
      JSON.stringify(new ClientDoctorModel());
    clientObject = JSON.parse(objectClient);
    return clientObject;
  }

  setRawMaterial(key: string, material: MissingProduct): void {
    sessionStorage.setItem(key, JSON.stringify(material));
  }
  getRawMaterial(key: string): MissingProduct {
    let data = new MissingProduct();
    const objectEdit =
      sessionStorage.getItem(key) ?? JSON.stringify(new MissingProduct());
    data = JSON.parse(objectEdit);
    return data;
  }
  setDetailOrderSAP(key: string, data: OpenOrdersReport): void {
    sessionStorage.setItem(key, JSON.stringify(data));
  }
  getDetailOrderSAP(key: string): OpenOrdersReport {
    let data = new OpenOrdersReport();
    const objectEdit = sessionStorage.getItem(key) ?? JSON.stringify(new OpenOrdersReport());
    data = JSON.parse(objectEdit);
    return data;
  }
  setInvoicesData(key: string, data: PayInvoicesData): void {
    sessionStorage.setItem(key, JSON.stringify(data));
  }
  getInvoicesData(key: string): PayInvoicesData {
    let data = new PayInvoicesData();
    const objectEdit =
      sessionStorage.getItem(key) ?? JSON.stringify(new PayInvoicesData());
    data = JSON.parse(objectEdit);
    return data;
  }

  removeInvoicesData(key: string): void {
    sessionStorage.removeItem(key);
  }

  setDetailOrderDataEdit(
    objectBack: BackIProductDetailStorage,
    key: string
  ): void {
    sessionStorage.setItem(key, JSON.stringify(objectBack));
  }

  setMissingProduct(data: MissingProduct, key: string): void {
    sessionStorage.setItem(key, JSON.stringify(data));
  }

  getMissingProduct(key: string): MissingProduct {
    let data = new MissingProduct();
    const dataStr =
      sessionStorage.getItem(key) ?? JSON.stringify(new MissingProduct());
    data = JSON.parse(dataStr) as MissingProduct;
    return data;
  }

  removeMissingProduct(key: string): void {
    sessionStorage.removeItem(key);
  }
  getDetailOrderDataEdit(key: string): BackIProductDetailStorage {
    let backStorage = new BackIProductDetailStorage();
    const objectEdit =
      sessionStorage.getItem(key) ??
      JSON.stringify(new BackIProductDetailStorage());
    backStorage = JSON.parse(objectEdit);
    return backStorage;
  }

  setRemovePrescriptionNames(): void {
    localStorage.removeItem(StorageConst.names);
  }

  setValidPrescriptionInfo(isValid: boolean): void {
    localStorage.setItem(
      StorageConst.isValidPrescriptionInfo,
      JSON.stringify(isValid)
    );
  }

  getValidPrescriptionInfo(): boolean {
    const isValidStr =
      localStorage.getItem(StorageConst.isValidPrescriptionInfo) ??
      JSON.stringify(BooleanCons.false);
    return JSON.parse(isValidStr) as boolean;
  }

  setMissingTabCreated(tab: TabsMissingProducts): void {
    localStorage.setItem(StorageConst.missingTab, JSON.stringify(tab));
  }

  getMissingTabCreated(): TabsMissingProducts {
    const item =
      localStorage.getItem(StorageConst.missingTab) ??
      JSON.stringify(TabsMissingProducts.rawMaterial);
    const tab = JSON.parse(item) as TabsMissingProducts;
    localStorage.removeItem(StorageConst.missingTab);
    return tab;
  }
  setInvoiceTab(tab: InvoiceTab): void {
    localStorage.setItem(StorageConst.invoiceTab, JSON.stringify(tab));
  }

  getInvoiceTab(): InvoiceTab {
    const item =
      localStorage.getItem(StorageConst.invoiceTab) ??
      JSON.stringify(InvoiceTab.pending);
    const tab = JSON.parse(item) as InvoiceTab;
    localStorage.removeItem(StorageConst.invoiceTab);
    return tab;
  }

  setFilterDoctorList(filter: string): void {
    localStorage.setItem(StorageConst.doctorFilter, filter);
  }
  getFilterDoctorList(): string {
    const item =
      localStorage.getItem(StorageConst.doctorFilter) ?? StringConst.empty;
    return item;
  }
  setDinamicParams(limits: CatalogField[]): void {
    localStorage.setItem(StorageConst.paymentLimit, JSON.stringify(limits));
  }
  getDinamicParams(): CatalogField[] {
    const item =
      localStorage.getItem(StorageConst.paymentLimit) ?? JSON.stringify([]);
    const limits = JSON.parse(item) as CatalogField[];
    return limits;
  }
  setLastCardSelected(card: PaymentCard): void {
    localStorage.setItem(StorageConst.lastCardSelected, JSON.stringify(card));
  }

  getLastCardSelected(): PaymentCard {
    const cardStr =
      localStorage.getItem(StorageConst.lastCardSelected) ??
      JSON.stringify(new PaymentCard());
    return JSON.parse(cardStr) as PaymentCard;
  }

  getLimitDaysOfCredit(): CreditValidation {
    const limitDays =
      localStorage.getItem(StorageConst.creditDaysLimit) ??
      JSON.stringify(new CreditValidation());
    const limit = JSON.parse(limitDays) as CreditValidation;
    return limit;
  }

  setLimitDaysOfCredit(creditValidation: CreditValidation): void {
    localStorage.setItem(
      StorageConst.creditDaysLimit,
      JSON.stringify(creditValidation)
    );
  }

  getValidationParams(needDaysValidation: boolean): string {
    const cardCode = this.getCardCodeGeneral();
    return `?cardcode=${cardCode}&needdaysvalidation=${needDaysValidation}`;
  }

  setNotificationSavedProducts(showed: boolean): void {
    localStorage.setItem(StorageConst.showedNotificacion, JSON.stringify(showed));
  }

  getNotificationSavedProducts(isFirstTime: boolean): boolean {
    const flag = localStorage.getItem(StorageConst.showedNotificacion);
    return Boolean(!flag && isFirstTime);
  }

  setShoppingTab(tab: ShoppingTab): void {
    localStorage.setItem(StorageConst.shoppingTab, JSON.stringify(tab));
  }

  getShoppingTab(): ShoppingTab {
    const item =
      localStorage.getItem(StorageConst.shoppingTab) ??
      JSON.stringify(ShoppingTab.shoppingCart);
    const tab = JSON.parse(item) as ShoppingTab;
    localStorage.removeItem(StorageConst.shoppingTab);
    return tab;
  }

  setSavedPage(page: CustomPaginatorEvent): void {
    localStorage.setItem(StorageConst.savedPage, JSON.stringify(page));
  }

  getSavedPage(): CustomPaginatorEvent {
    const page = new CustomPaginatorEvent();
    page.limit = NumberCons.ten;
    const item = localStorage.getItem(StorageConst.savedPage) ?? JSON.stringify(page);
    return JSON.parse(item) as CustomPaginatorEvent;
  }

  setProfileTabRedirection(tab: number): void {
    localStorage.setItem(StorageConst.myProfileTab, tab.toString());
  }

  getProfileTabRedirection(): number {
    const tab = localStorage.getItem(StorageConst.myProfileTab) ?? NumberCons.zero;
    localStorage.removeItem(StorageConst.myProfileTab);
    return Number(tab);
  }

  setMinPiecesQuantity(pieces: number): void {
    localStorage.setItem(StorageConst.minPiecesQuantity, pieces.toString());
  }

  getMinPiecesQuantity(): number {
    const tab = localStorage.getItem(StorageConst.minPiecesQuantity) ?? NumberCons.zero;
    return Number(tab);
  }

  setAddSearch(search: string): void {
    const newSearch = new SearchValue(search);
    const searches = this.getSearch();
    if (!searches.map(x => x.value.toUpperCase()).includes(newSearch.value.toUpperCase())) {
      searches.push(newSearch);
      localStorage.setItem(StorageConst.generalSearch, JSON.stringify(searches));
    }
  }

  getSearch(): SearchValue[] {
    const item = localStorage.getItem(StorageConst.generalSearch) ?? JSON.stringify([]);
    return JSON.parse(item) as SearchValue[];
  }

  setResponsibleDoctor(doctor: string): void {
    localStorage.setItem(StorageConst.responsibleDoctorId, doctor);
  }

  getResponsibleDoctor(): string {
    const doctorId = localStorage.getItem(StorageConst.responsibleDoctorId) ?? StringConst.empty;
    return doctorId;
  }

  setResponsibleDoctorAddressNick(doctorAddress: string): void {
    localStorage.setItem(StorageConst.responsibleDoctorAddressNick, doctorAddress);
  }

  getResponsibleDoctorAddressNick(): string {
    const addressNick = localStorage.getItem(StorageConst.responsibleDoctorAddressNick) ?? StringConst.empty;
    return addressNick;
  }

  setPagination(page: Pagination): void {
    const pagination = JSON.stringify(page);
    localStorage.setItem(StorageConst.pagesTable, pagination);
  }

  getPagination(): Pagination {
    const pages = localStorage.getItem(StorageConst.pagesTable) ?? JSON.stringify(new Pagination());
    localStorage.removeItem(StorageConst.pagesTable);
    return JSON.parse(pages) as Pagination;
  }
}
